<template>
	<el-pagination :current-page="page" @current-change="pageChange" @size-change="sizeChange" background :layout="layout" :total="total" :page-sizes="pageSizes"></el-pagination>
</template>

<script>
export default {
	props: ['total', 'page'],
	data() {
		return {};
	},
	computed: {
		layout() {
			return this.$store.getters.pagination.layout;
		},
		pageSizes() {
			return this.$store.getters.pagination.pageSizes;
		}
	},
	methods: {
		pageChange(page) {
			this.$emit('current-change', page);
		},
		sizeChange(size) {
			this.$emit('size-change', size);
		}
	}
};
</script>

<style></style>
